import Base from '../Base';
import Map from '../components/Map.js';

export default class Zones extends Base {
    init(id, main, locale) {
        console.log(':: Zones ::');
        
        var table = document.querySelector("#ancientZone");
        if(table){
            var tableContainer = table.querySelectorAll(".tableContainer");

            if(tableContainer){
                for(let i = 0; i < tableContainer.length; i++){
                  tableContainer[i].addEventListener("scroll", () => {
                      document.querySelectorAll(".table-overlay")[i].style.display = "none";
                  });
          
                  tableContainer[i].addEventListener("click", () => {
                      document.querySelectorAll(".table-overlay")[i].style.display = "none";
                  });
                }
              }
            
        }
        
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });

        const inputSearch = document.getElementById('myInputSearch');

        if (inputSearch) {
            inputSearch.onkeyup = e => {
                this.searchThroughList(e);
            };
        }

        var map = new Map();
        map.init();
    }
}